<template>
    <div>
      <div class="modal hide fade" id="modalPurchasingInventoryDetail" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingInventoryDetail" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Purchase Order - <b>{{ purchasingOrder.purchasing_no }}</b> | <span class="badge badge-primary">{{ purchasingOrder.status }}</span></h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4">
                  <dl class="row">
                    <dt class="col-sm-4">Order No.</dt>
                    <dd class="col-sm-8">{{ purchasingOrder.sp_no }}</dd>
                  </dl>
                  <dl class="row">
                    <dd class="col-sm-4">Tanggal</dd>
                    <dd class="col-sm-8">{{ purchasingOrder.purchasing_date | dateFormat('DD/MM/YYYY') }}</dd>
                  </dl>
                  <dl class="row">
                    <dd class="col-sm-4">Jatuh Tempo</dd>
                    <dd class="col-sm-8">{{ purchasingOrder.purchasing_due_date | dateFormat('DD/MM/YYYY') }}</dd>
                  </dl>
                </div>
                <div class="col-md-4">
                  <dl class="row">
                    <dd class="col-sm-4">Vendor</dd>
                    <dd class="col-sm-8">{{ purchasingOrder.vendor }}</dd>
                  </dl>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-item table-sm table-hover table-striped">
                      <thead>
                        <th>Product No.</th>
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Qty Done</th>
                        <th>Uom</th>
                        <th>subtotal</th>
                        <th>Discount</th>
                        <th>Tax</th>
                        <th>Total</th>
                        <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="d in purchasingOrder.details" :key="d.id">
                          <td>{{ d.product_no }}</td>
                          <td>{{ d.product }}</td>
                          <td>{{ d.qty }}</td>
                          <td>{{ d.qty_done }}</td>
                          <td>{{ d.uom_id }}</td>
                          <td>{{ d.subtotal }}</td>
                          <td>{{ d.discount }}</td>
                          <td>{{ d.tax }}</td>
                          <td>{{ d.total }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal hide fade" id="modalPurchasingOrderVendor" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingOrderVendor" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Order List</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive">
                <div class="alert alert-info" role="alert">
                  <i class="fa fa-info-circle font-24" aria-hidden="true"></i> <b>Order</b> harus di <b>Approve</b> sebelum dapat dilakukan proses <b>pembelian</b>
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="form-inline ml-auto">
                  <div class="button-group">
                    <button type="button" class="btn btn-sm btn-soft-primary" @click="selectMulti" data-dismiss="modal">Select</button>
                    rows:
                    <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                      <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                    </select>
                    <span class="mr-1">
                      Total rows: <b>{{ inventoryList.length }}</b>
                    </span>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">
                    page:
                    <select v-model="currentPage">
                      <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                    </select>
                    / {{ pageLength }}
                  </span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm table-hover">
                  <thead>
                    <th>
                      <label class="form-checkbox">
                        <input type="checkbox" v-model="selectAll" @click="select">
                        <i class="form-icon"></i>
                      </label>
                    </th>
                    <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                          {{ t.name }}
                          <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                    </th>
                  </thead>
                  <tbody>
                    <tr v-for="v in filterData" :key="v.id">
                      <td>
                        <label class="form-checkbox" v-if="v.status === 'approve'">
                          <input type="checkbox" :value="v.id" v-model="selected">
                          <i class="form-icon"></i>
                        </label>
                      </td>
                      <td>
                        <span class="badge badge-primary" v-if="v.status ==='order'">{{ v.status }}</span>
                        <span class="badge badge-info" v-else>{{ v.status }}</span>
                      </td>
                      <td>{{ v.purchasing_no }}</td>
                      <td>{{ v.sp_no }}</td>
                      <td>{{ v.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>{{ v.vendor }}</td>
                      <td>{{ v.total | currency }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PurchasingInventoryModal',
  props: ['company'],
  data () {
    return {
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      selectAll: false,
      selected: [],
      title: [{
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Purchasing No.',
        prop: 'purchasing_no'
      }, {
        name: 'Order No.',
        prop: 'sp_no'
      }, {
        name: 'Tanggal',
        prop: 'purchasing_date'
      }, {
        name: 'Vendor',
        prop: 'vendor'
      }, {
        name: 'Total',
        prop: 'total'
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      inventoryList: state => state.inventories.inventoryApproveList,
      rowsTable: state => state.data.rowsTable,
      purchasingOrder: state => state.purchasings.purchasingOrder,
      vendorOrderList: state => state.vendors.vendorOrderList
    }),
    pageLength: function () {
      var length = this.inventoryList.length / this.pageSize
      return Math.ceil(length)
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.vendorOrderList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => d.company_no === this.company).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    selectMulti () {
      var loop = []
      var array = this.selected
      for (let i = 0; i < array.length; i++) {
        loop.push(this.vendorOrderList.find(d => d.id === array[i]))
      }
      this.$emit('selectOrderMulti', loop)
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.inventoryList.length) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    }
  }
}
</script>
